import {
  GET_ACCESSIBLE_ATTENDANCE,
  GET_ACCESSIBLE_MODULE_ATTENDANCE,
  RESET_ACCESSIBLE_ATTENDANCE_DATA
} from './accessible-action-types'
import {
  RESET_ACCESSIBLE_ATTENDANCE,
  SET_ACCESSIBLE_ATTENDANCE,
  SET_ACCESSIBLE_MODULE_ATTENDANCE,
  SET_FILTERED_ATTENDANCE,
  SET_FILTERED_MODULE_ATTENDANCE
} from './accessible-mutation-types'
import * as axios from 'axios'

const state = {
  allAttendanceSummary: [],
  attendanceSummary: [],
  overallAttendance: 0,
  filters: [],
  loading: true
}

function setOverallPercentage (overallPercentageRecords, state) {
  if (overallPercentageRecords && overallPercentageRecords.length !== 0) {
    const totalAttended = overallPercentageRecords.reduce((n, {attended}) => n + attended, 0)
    const totalExpected = overallPercentageRecords.reduce((n, {expected}) => n + expected, 0)
    if (totalExpected !== 0) {
      state.overallAttendance = Math.round((totalAttended / totalExpected) * 100)
    } else {
      state.overallAttendance = 0
    }
  } else {
    state.overallAttendance = 0
  }
}

function setAttendanceRecords (events, state) {
  if (events.length === 0) {
    state.allAttendanceSummary = []
    state.attendanceSummary = []
  } else {
    state.allAttendanceSummary = events
    // setting the filters
    const uniques = [...new Set(events.map(item => item.year))]
    let distinctYears = uniques.sort().reverse()
    state.filters = distinctYears
  }
  state.loading = false
}

const mutations = {
  [SET_ACCESSIBLE_ATTENDANCE] (state, events) {
    setAttendanceRecords(events, state)
  },
  [SET_ACCESSIBLE_MODULE_ATTENDANCE] (state, events) {
    setAttendanceRecords(events, state)
  },
  [SET_FILTERED_ATTENDANCE] (state, year) {
    state.attendanceSummary = state.allAttendanceSummary.filter(item => item.year === year && item.description)
    const overallPercentageRecords = state.allAttendanceSummary.filter(item => item.year === year && item.description)
    setOverallPercentage(overallPercentageRecords, state)
  },
  [SET_FILTERED_MODULE_ATTENDANCE] (state, year) {
    state.attendanceSummary = state.allAttendanceSummary.filter(item => item.year === year)
    const overallPercentageRecords = state.allAttendanceSummary.filter(item => item.year === year)
    setOverallPercentage(overallPercentageRecords, state)
  },
  [RESET_ACCESSIBLE_ATTENDANCE] (state) {
    state.allAttendanceSummary = []
    state.attendanceSummary = []
    state.overallAttendance = 0
    state.filters = []
    state.loading = true
  }
}

function loadHistory (rootState, state, studentId, actionData) {
  return axios({
    url: `${rootState.config.baseUrl}:${rootState.config.port}/core/student/${studentId}/attendance/accessible`,
    method: 'get',
    headers: {
      'Authorization': rootState.profile.loginToken
    },
    actionData
  })
}

function loadHistoryForModules (rootState, state, studentId, actionData) {
  return axios({
    url: `${rootState.config.baseUrl}:${rootState.config.port}/core/student/${studentId}/attendance/accessible/modules`,
    method: 'get',
    headers: {
      'Authorization': rootState.profile.loginToken
    },
    actionData
  })
}

const actions = {
  async [GET_ACCESSIBLE_ATTENDANCE] ({rootState, commit}, studentId) {
    const actionData = { action: 'GET_ACCESSIBLE_ATTENDANCE', data: studentId }
    loadHistory(rootState, state, studentId, actionData)
      .then((res) => {
        const rxs = res.data.map((item) => {
          return {
            year: item.year,
            description: item.description,
            attended: item.attended,
            expected: item.expected,
            percentage: item.percentage + '%'
          }
        })
        commit(SET_ACCESSIBLE_ATTENDANCE, rxs)
      })
      .catch((err) => {
        console.error(err)
      })
  },
  async [GET_ACCESSIBLE_MODULE_ATTENDANCE] ({rootState, commit}, studentId) {
    const actionData = { action: 'GET_ACCESSIBLE_MODULE_ATTENDANCE', data: studentId }
    loadHistoryForModules(rootState, state, studentId, actionData)
      .then((res) => {
        const rxs = res.data.map((item) => {
          return {
            year: item.year,
            moduleCode: item.moduleCode,
            moduleDescription: item.moduleDescription,
            attended: item.attended,
            expected: item.expected,
            percentage: item.percentage + '%'
          }
        })
        commit(SET_ACCESSIBLE_MODULE_ATTENDANCE, rxs)
      })
      .catch((err) => {
        console.error(err)
      })
  },
  [RESET_ACCESSIBLE_ATTENDANCE_DATA] ({commit}) {
    commit(RESET_ACCESSIBLE_ATTENDANCE)
  }

}

export default {
  state,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/accessibility/accessibleAttendance.js